<template>
    <div class="ds-segmented-picker bonusomat-board-filter">
        <nav class="ds-segmented-picker__nav is-dark">
            <button
                class="ds-segmented-picker__toggle is-dark"
                :class="{ 'is-active ': selectedValue === item.value }"
                v-for="(item, index) in options"
                :key="index"
                @click="selectedValue = item.value"
            >
                <span class="ds-segmented-picker__text" :data-title="item.text">
                    <span class="ds-segmented-picker__text-inner">{{ item.text }}</span>
                </span>
            </button>
        </nav>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { BonusomatFilterValues, BoardFilterOption } from "../../models/bonusomat-board-filter";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";

const props = defineProps<{
    modelValue: string;
    options: BoardFilterOption[];
}>();
const emit = defineEmits(["update:modelValue"]);

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const getAnalyticsFilterItemLabel = (filterValue: string) => {
    switch (filterValue) {
        case "":
            return "Vše";
        case "uncompleted":
            return "Nesplněné";
        case "completed":
            return "Splněné";
        case "repeating":
            return "Opakující se";
        default:
            return "Unknown";
    }
};

const selectedValue = computed({
    get() {
        return props.modelValue;
    },
    set(newValue) {
        if (props.modelValue === newValue) {
            emit("update:modelValue", BonusomatFilterValues.All);
        } else {
            emit("update:modelValue", newValue);
        }
        BonusomatDatalayer.pushBoardFilterItemClick(
            getAnalyticsFilterItemLabel(newValue),
            bonusomatPlayerData.value.points,
            remainingSpinsCount.value
        );
    },
});
</script>
